import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Subscription } from "@modules/subscriptions/types";
import { SubscriptionFormValues } from "@modules/subscriptions/validations";
import { editSubscriptionService } from "./service";
import { UseEditSubscriptionMutationOptions } from "./types";

export function useEditSubscriptionMutation(
  options?: UseEditSubscriptionMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Subscription, ApiError, { id: string; data: SubscriptionFormValues }>({
    mutationFn: ({ id, data }) => editSubscriptionService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("subscription_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
